import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface ArticleViews {
    count: number | null;
    isEnabled: boolean;
}

export default autoGeneratedReducer<ArticleViews>(null);
